<template>
    <v-dialog v-model="dialog" width="800px" class="pa-0 ma-0">
        <v-card>
            <v-card-title class="justify-center">Choose a prompt for a questions</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-row cols="12" class=" pt-2">
                    <v-col cols="5">
                        <v-text-field v-model="search" clearable prepend-icon="mdi-magnify" label="Search through all fields" single-line hide-detail dense/>
                    </v-col>
                    <v-col cols="7">
                        <v-select v-model="category" :items="categories" item-value="Option" item-text="Description" label="Category" small-chips multiple clearable dense></v-select>
                    </v-col>
                </v-row>
                <v-data-table 
                    dense 
                    :headers="getHeaders()" 
                    :items="filteredPrompts" 
                    :disable-pagination=true
                    hide-default-footer 
                    item-key="oapr_nr" 
                    fixed-header 
                    :search="search"
                    :height="200"
                    >
                    <template v-slot:item="prompt">
                        <tr @click="choosePrompt(prompt.item)">
                            <td>{{ prompt.item.oapr_nr }}</td>
                            <td>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">{{ prompt.item.oact_code }}</span>
                                    </template>
                                    <span v-if=" prompt.item.oact_oms!==''">{{ prompt.item.oact_oms }}</span>
                                </v-tooltip>                                                       
                            </td>
                            <td>{{ prompt.item.oapr_oms }}</td>
                            <td>
                                <v-tooltip bottom >
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">Details</span>
                                    </template>
                                    <span>{{ prompt.item.oapr_prompt }}</span>
                                </v-tooltip>                                 
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                Click on prompt to choose it 
                <v-spacer></v-spacer>
                <!-- <v-btn color="primary" small @click="chooseAction">Save</v-btn> -->
                <v-btn color="primary" small @click="cancelAction">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        components: {
        },
        props: {
        },
        data() {
            return {
                dialog: false,
                question: {},
                search: "",

                prompt_nr: [],
                prompts: [],

                // Selected categories & category options
                category: [],
                categories: [],
            }
        },
        computed: {
            filteredPrompts: function() {            
                return this.prompts.filter((prompt) => {
                    if (!this.match_field(this.category, prompt.oact_code)) {
                        return false;
                    }                   
                    return true;
                })
            }     
        }, 
        methods: { 
            openDialog(question) {
                this.question = question;
                this.getPrompts();
            },
            match_field(options, value) {
                if (options.length === 0) { return true } 
                for(let idx=0; idx < options.length; idx++) {                         
                    if(options[idx] === value) {
                        return true;
                    }
                }
                return false;                
            },  
            getPrompts() {
                this.dialog = false;
                this.$axios.post("ares/json/ares/task/customer_success/openai/getPromptsOverview.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getPromptsOverview"
                    },
                    getPromptsOverview: {
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    } else {
                        this.prompts = res.data.getPromptsOverview;
                        this.categories = res.data.oact;
                        this.dialog = true;
                    }
                });
            },
            getHeaders() {
                return [
                    { text: "Nr", value: "oapr_nr", sortable: true},
                    { text: "Category", value: "oact_code", sortable: true},
                    { text: "Prompt description", value: "oapr_oms", sortable: true},
                ];
            },
            choosePrompt(prompt) {
                this.question.oavr_vraag = prompt.oapr_prompt;
                this.dialog = false;
            },
            cancelAction() {
                this.dialog = false;
            },
        }
    }
</script>